<div class="card card--activity">
  <div class="card__title">Activity <a class="card__title-link" routerLink="/activity">View All</a></div>
  <div class="card__content">
    <div class="notif notif--activity">
      <div class="notif-item">
        @if (activities().length > 1) {
          @for (activity of activities(); track activity.id) {
          <p class="notif-item__date">{{ activity.dateSent | date:'MMM dd, yyyy' }}</p>
          <div class="notif-item__text" [innerHTML]="activity.content"></div>
          }
        } @else {
        <div class="notif-item__text">No recent activity</div>
        }
      </div>
    </div>
  </div>
</div>
